<template>
<div class="row wrapper">
    <div class="image_login col-lg-6">
        <div class="container">
            <img src="../assets/image/profiling_illustration.svg" class="login_img profiling_img" alt="">
        </div>
    </div>
    <div class="login_form col-lg-6 my-auto profiling">
        <div class="container">
            <div class="d-flex justify-content-between">
                <h1 class="fw-bold title my-3">Profiling</h1>
                <!-- <button class="btn" @click="goToDash()">Skip</button> -->
            </div>
            <div class="questions">
                <div class="alert alert-danger" v-if="message && !success" role="alert">
                    {{message.message || message.answers[0]}}
                </div>
                <div class="alert alert-danger" v-if="empty  && !success" role="alert">
                    {{empty}}
                </div>
                <div class="alert alert-success" v-if="success" role="alert">
                    {{success.message}}
                </div>
                <p class="d-none">{{this.store.answers}}</p>
                <form @submit.prevent="handleProfiling">
                    <div class="mb-3" v-for="(list, index) in questOpt" :key="index">
                        <label for="q1">{{list.question}}</label>
                        <!-- <input type="text" :value="index" class="form-control" id="id_quest" readonly> -->
                            <!-- <input class="form-check-input" type="checkbox" v-model="state.question_id[index]" :value="list.id" :id="'q'+list.id"> -->

                        <div class="form-check" v-for="opt in list.options" :key="opt.id">
                            <input class="form-check-input" type="radio" v-model="selectedOpt[index]" @change="setV(opt)" :value="opt.id" :id="'option'+opt.id" :name="opt.id+opt.option">
                            <!-- <input class="form-check-input" type="radio" v-model="answers[index]" :value="opt.id" :id="'option'+opt.id" :name="opt.option"> -->
                            <label class="form-check-label" :for="'option'+opt.id">
                                {{opt.option}}
                            </label>
                        </div>
                    </div>
                    <div class="mb-3 text-end">
                        <button type="submit" class="btn btn_red" :disabled="loading" id="btnsubmit">
                            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                            <span v-if="loading">Loading</span>
                            <span v-if="!loading">Save
                            <i class="fas fa-caret-right"></i>
                            </span>
                        </button>
                    </div>
                </form>
            </div>
            
        </div>
    </div>
    <div :class="submitdata ? 'show d-block fade': ''" class="modal " id="modalBroker" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content datacontent">
                <div class="modal-body modalbroker">
                    <div>
                        <figure>
                            <img src="../assets/loadingeclips.svg" alt="">
                        </figure>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div :class="submitdata ? 'show fade modal-backdrop': ''" class=" "></div>
</div>
</template>

<script>
import axios from 'axios'
import swal from "sweetalert"

export default {
    name: 'Profiling',
    data(){
        return{
            question: [],
            options: [],
            akun: [],
            questOpt: [],
            profiling: [],
            loading: false,
            submitdata: false,
            store: {
                investor_id: localStorage.getItem('user_id'),
                answers: [],
            },
            state: {
                investor_id: localStorage.getItem('user_id'),
                answers: [],
            },
            // answers: [
            //     {
            //         question_id: '',
            //         option_id: '',
            //     }
            // ]
            selectedOpt: [],
            message: '',
            empty: '',
            success: '',
        }
    },
    async mounted(){
        // const API_URL = 'http://103.153.62.26:8085/api/'

        await axios.get(`profiling/results?investor_id=${localStorage.user_id}`)
		.then(result => {
			// console.log('Profiling: ', result.data.data)
			this.profiling = result.data.data
		}).catch(() => {
			// console.log('Error Profiling: ', err.response)
		})

        await axios.get(`profiling/`)
        .then(result => {
            var quest = result.data.data
            // this.question = result.data.data
            for (let i = 0; i < quest.length; i++) {
                axios.get(`profiling/${quest[i].id}/options/`)
                .then(response => {
                    var opt_list = {}
                    // console.log('Question: ', quest[i].question)
                    // this.questions = quest[i]
                    // this.question.push(quest[i])
                    // console.log('Question: ', quest[i].question)
                    var opt = response.data.data
                    // var opt_list = {}
                    // this.options = response.data.data
                    for (let j = 0; j < opt.length; j++) {
                        // console.log('Options: ', opt[j].option)
                        
                        // this.options.push(opt[j])
                        opt_list['id'] = quest[i].id
                        opt_list['question'] = quest[i].question
                        opt_list['options'] = opt
                    }
                    this.questOpt.push(opt_list)
                }).catch(() => {
                    // console.log('Error Profiling Options: ', err.response)
                })
            }
            // console.log("Question & Option All : ", this.questOpt)
            // this.question = result.data.data
        }).catch(() => {
            this.loading = false
            // console.log('Error Profiling Question: ', err.result)
        })
        
        await axios.get(`investor/${localStorage.user_id}`)
		.then(result => {
			// console.log('Profile: ', result.data.data)
			this.akun = result.data.data
			if(result.data.data.identity_file == null && result.data.data.comparison_file == null && result.data.data.selfie_image == null)
            {
              this.$router.push('profile/update')
            } else if(result.data.data.profiling_risk_level !== null){
                this.$router.push('/dash')
            }
		}).catch(() => {
            this.loading = false
			// console.log('Error Profile: ', err.response)
		})


    },
    methods: {
        alertErrorMessage(message, textButton){
            swal('Opps... Something wrong',`${message}`, 'error',{
                    button: {
                        textButton: `${textButton}`,
                    },
                    dangerMode: true,
                }).then(()=>{
                    this.loading = false
                    this.submitdata = false
                })
        },
        goToDash(){
            this.$router.push('/dash');
        },
        setV(opt){

            var answer = {'question_id': opt.question_id, 'option_id': opt.id}
            this.store.answers.push(answer)

            // console.log('All Answer: ', this.store.answers)
            this.store.answers.forEach((list, index) => {
                if(list.question_id === answer.question_id) {
                    // console.log('Masuk IF');
                    this.store.answers[index] = answer;
                }
            });

            // const result = this.store.answers.map(item => [item.question_id, item])
            
            // console.log('All Answer: ', result)
            // console.log('All Answer: ', this.store.answers)

            
            // console.log('All Answer: ', this.selectedOpt)
            // console.log('Answer Selected: ', this.selectedOpt)
            // for(let i=0; i<this.store.answers.length; i++){
            //     var answer = {'question_id': opt.question_id, 'option_id': opt.id}
            //     if(answer.question_id !== this.store.answers[i].question_id)
            //     {
            //         this.store.answers.push(answer)
            //     }
            // }
            // console.log('Answer: ', this.store.answers)
            
            // this.answers.question_id.push({question_id : list.id})
            // if (list.id == opt.question_id) {
            //     // this.state.question_id.slice(0,1)
            // } else {
            //     this.state.question_id.slice(0,1)
            //     // this.state.question_id.push(list.id)
            //     // this.state.question_id = list.id
            // }
        },
        test(){
            // const uniqueElementsBy = (arr, fn) =>
            //     arr.reduce((acc, v) => {
            //         if (!acc.some(x => fn(v, x))) acc.push(v);
            //         return acc;
            //     }, []);
            
            // const result = uniqueElementsBy(this.store.answers,(a, b) => a.question_id == b.question_id);
            // console.log('Final: ', JSON.stringify(result));
        },
        handleProfiling(){
            this.loading = true
            this.submitdata = true
            document.getElementById('btnsubmit').disabled = true
            const uniqueElementsBy = (arr, fn) =>
                arr.reduce((acc, v) => {
                    if (!acc.some(x => fn(v, x))) acc.push(v);
                    return acc;
                }, []);
            
            this.state.answers = uniqueElementsBy(this.store.answers,(a, b) => a.question_id == b.question_id);
            // console.log('Final: ', this.state.answers);
            // alert(JSON.stringify(this.answers))
            let data = new FormData()
            data.append('investor_id', this.investor_id)
            data.append('answers', JSON.stringify(this.state.answers))
            // data.append('question_id', this.answers.question_id)
            // data.append('option_id', this.answers.option_id)
            // console.log('Get Answer: ', JSON.stringify(this.state))

            axios.post(`profiling/results/`, JSON.stringify(this.state))
            // axios({
            //     method: "post",
            //     url: `profiling/results/`,
            //     data: JSON.stringify(data),
            //     config: { headers }
            // })
            .then((response) => {
                // console.log('success: ', response)
                this.success = response.data
                this.answers = []
                this.selectedOpt = []
                this.loading = false
                this.submitdata = false
                swal('Successfully', 'your data has been submit', 'success', {
                    button: "OK"
                }).then(()=>{
                    document.getElementById('btnsubmit').disabled = false
                    this.$router.push('/dash')
                    
                })
                // setTimeout(() => {
                    // document.getElementById('btnsubmit').disabled = false
                    // this.$router.push('/dash')
                // }, 3000)
            }).catch((err) => {
                this.loading = false
                document.getElementById('btnsubmit').disabled = false
                // console.log('Error Bro: ', err)
                if (err.data.status === 500) {
                    this.loading = false
                    this.empty = 'Please fill the profiling answers!'
                    setTimeout(() => {
                        this.empty = false
                    }, 5000)
                    // console.log("Kosong, Silahkan isi semua profiling!!");
                } else if(err.data.status === 400){
                    this.loading = false
                    this.message = err.data
                    this.alertErrorMessage(this.message.data.answers[0], 'OK')
                    // console.log('Error 400: ', err.data);
                    
                } else{
                    this.loading = false
                    this.message = err.data
                    this.answers = []
                    this.state.answers = []
                    this.selectedOpt = []
                    this.alertErrorMessage(this.message.data.answers[0], 'OK')
                    // console.log('Error I: ', err)
                }
                this.loading = false
                // console.log('Error: ', err)
            })
            this.loading = false
        }
    }

}
</script>

<style scoped>
.datacontent{
    border: 0px !important;
    box-shadow: 0px 0px 0px  #0000 !important;
    background-color: transparent !important;
}
.modalbroker figure{
    width: 125px;
    margin: 0 auto !important;
}
.modalbroker img{
    width: 100%;
}
</style>
<style>
.profiling .title{
    color: var(--red);
}
.profiling{
    height: 100vh;
    min-height: 300px;
}
img.profiling_img{
    width: 60%;
    display: block;
    margin: 0 auto;
}
.profiling .questions{
    overflow-y: scroll;
    max-height: calc(100vh - 120px);
    padding: 0 20px 0 0;
}
.profiling .questions::-webkit-scrollbar {
    /* width: 10px; */
    width: 8px;
}
/* Track */
.profiling .questions::-webkit-scrollbar-track {
    /* box-shadow: inset 0 0 4px grey;  */
    background: #f1f1f1;
    border-radius: 5px;
}
/* Handle */
.profiling .questions::-webkit-scrollbar-thumb {
    background: #d6d6d6; 
    border-radius: 5px;
}
/* Handle on hover */
.profiling .questions::-webkit-scrollbar-thumb:hover {
    background: #c7c7c7; 
}
.my-custom-button {
    background-color: #E50019 !important; /* Green background */
    color: white !important; /* White text */
  }
</style>